/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Question(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M10.8867 13.6846V13.1787C10.8867 12.8688 10.93 12.5954 11.0166 12.3584C11.1032 12.1169 11.2422 11.889 11.4336 11.6748C11.625 11.4561 11.8779 11.2327 12.1924 11.0049C12.4749 10.8044 12.7005 10.6243 12.8691 10.4648C13.0423 10.3053 13.1676 10.1481 13.2451 9.99316C13.3271 9.83366 13.3682 9.65365 13.3682 9.45312C13.3682 9.1569 13.2588 8.93132 13.04 8.77637C12.8213 8.62142 12.516 8.54395 12.124 8.54395C11.7321 8.54395 11.3424 8.60547 10.9551 8.72852C10.5723 8.85156 10.1826 9.01335 9.78613 9.21387L9.04102 7.7168C9.49674 7.46159 9.99121 7.25651 10.5244 7.10156C11.0576 6.94206 11.641 6.8623 12.2744 6.8623C13.2497 6.8623 14.0039 7.09701 14.5371 7.56641C15.0749 8.03125 15.3438 8.6237 15.3438 9.34375C15.3438 9.72656 15.2822 10.0592 15.1592 10.3418C15.0407 10.6198 14.8584 10.8796 14.6123 11.1211C14.3708 11.3581 14.0677 11.6087 13.7031 11.873C13.4297 12.0736 13.2201 12.2422 13.0742 12.3789C12.9284 12.5156 12.8281 12.6523 12.7734 12.7891C12.7233 12.9212 12.6982 13.083 12.6982 13.2744V13.6846H10.8867ZM10.668 16.0225C10.668 15.5941 10.7842 15.2933 11.0166 15.1201C11.2536 14.9469 11.5384 14.8604 11.8711 14.8604C12.1947 14.8604 12.4727 14.9469 12.7051 15.1201C12.9421 15.2933 13.0605 15.5941 13.0605 16.0225C13.0605 16.4326 12.9421 16.7288 12.7051 16.9111C12.4727 17.0934 12.1947 17.1846 11.8711 17.1846C11.5384 17.1846 11.2536 17.0934 11.0166 16.9111C10.7842 16.7288 10.668 16.4326 10.668 16.0225Z"
        fill={color}
      />
      <circle cx="12" cy="12" r="8.25" stroke={color} strokeWidth="1.5" />
    </svg>
  );
}

Question.defaultProps = {
  color: "currentColor",
  size: 24,
};

Question.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
